import { getOrgRooms } from 'api/rooms.api';
import { getOrgFolders } from 'api/folders.api';
import displayError from 'utils/displayError';
import { $list, $view } from 'signals/global.signals';
import { getOrgDocuments } from 'api/documents.api';
import mergeDocumentsAndFolders from 'utils/mergeFilesAndFolders';
import { getUserOrgDeals } from 'api/deals.api';
import { getOrgInvestors } from 'api/investors.api';

export async function fetchAndSetRoomsData() {
  try {
    $view.update({
      isTableLoading: true,
    });
    const [{ data: folders }, { data: documents }, { data: rooms }, { data: deals }, { data: investors }] = await Promise.all([
      getOrgFolders(),
      getOrgDocuments(),
      getOrgRooms(),
      getUserOrgDeals(),
      getOrgInvestors(),
    ]);

    const dealOptions = deals.map((deal) => ({
      label: deal.name,
      value: deal.id,
      usesOfCapital: deal.usesOfCapital,
      currentValue: deal.currentValue,
      minimumInvestment: deal.minimumInvestment,
      typeOfRaise: deal.typeOfRaise,
      cap: deal.cap,
      discountPercent: deal.discountPercent,
      interestRate: deal.interestRate,
    }));

    const investorOptions = investors.map((investor) => ({
      label: `${investor.investorName} - ${investor.email}`,
      value: investor.email,
    }));

    const mergedFolders = mergeDocumentsAndFolders(documents, folders);

    $view.update({
      folders: mergedFolders,
      dealOptions,
      investorOptions,
    });
    $list.update({
      data: rooms,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load rooms data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({
      isTableLoading: false,
    });
  }
}
